var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-line-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 51.7423C4.06828 51.7423 3.3125 50.9865 3.3125 50.0548C3.3125 49.1231 4.06828 48.3673 5 48.3673H50C50.9317 48.3673 51.6875 49.1231 51.6875 50.0548C51.6875 50.9865 50.9317 51.7423 50 51.7423H5ZM27.5 38.2423C28.4317 38.2423 29.1875 37.4865 29.1875 36.5548V9.12843L37.5568 17.4978C37.8864 17.8274 38.3182 17.9921 38.75 17.9921C39.1818 17.9921 39.6136 17.8274 39.9432 17.4978C40.6024 16.8385 40.6024 15.7707 39.9432 15.1116L28.6932 3.86163C28.0339 3.20237 26.9661 3.20237 26.3071 3.86163L15.0568 15.1116C14.3976 15.7709 14.3976 16.8387 15.0568 17.4978C15.7161 18.1568 16.7839 18.157 17.443 17.4978L25.8123 9.12843V36.5548C25.8123 37.4865 26.5683 38.2423 27.5 38.2423Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.79432df40dcba61896951c7a1dba41ea.svg";
export { ForwardRef as ReactComponent };